<template>
  <div>
    <section class="p-box">
      <header class="p-box__header">
        <div class="filter__wrapper p-filtersA">
          <div class="p-filtersA__left">
            <slot name="leftHeader" />
          </div>
          <div class="p-filtersA__right">
            <slot name="rightHeader" />
          </div>
        </div>
      </header>
      <div class="p-box__body">
        <Loading v-show="loading" />
        <template v-if="!loading && mediaLibrary">
          <div class="c-grid">
            <div class="c-grid__items">
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__6 c-grid__item__l__6">
                <section class="p-box">
                  <div class="p-photos__image">
                    <div :style="{ 'background-image': `url(${ mediaLibrary.mediaImageUrl })` }" />
                  </div>
                </section>
              </div>
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__6 c-grid__item__l__6">
                <section class="detail__container p-box">
                  <div class="p-box__body">
                    <h3 class="detail__title p-box__title">
                      {{ $t('pages.CompaniesLocationStoreMediaLibrary.infoTitle') }}
                    </h3>
                    <ul class="value__list">
                      <li class="value__item">{{ $t('models.mediaLibrary.fileName') }}：<span class="value__text">{{ mediaLibrary.fileName }}</span></li>
                      <li class="value__item">{{ $t('models.mediaLibrary.fileUploadedAt') }}：<span class="value__text">{{ uploadedTime }}</span></li>
                      <li class="value__item">{{ $t('models.mediaLibrary.fileUploadUser') }}：<span class="value__text">{{ fileUploadUserName }}</span></li>
                      <li class="value__item">{{ $t('models.mediaLibrary.fileSize') }}：<span class="value__text">{{ fileSize }}</span></li>
                    </ul>

                    <slot name="moreDetail" />
                  </div>
                </section>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="p-box__body">
        <slot name="extra" />
      </div>
    </section>
  </div>
</template>

<script>
import { basicDateFormat } from '../../modules/date'
import Loading from '../Loading.vue'

export default {
  name: 'MediaLibraryDetailLayout',
  components: {
    Loading
  },
  props: {
    mediaLibrary: {
      type: Object
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    fileUploadUserName() {
      return this.mediaLibrary.fileUploadUser.lastName + ' ' + this.mediaLibrary.fileUploadUser.firstName
    },
    fileSize() {
      const size = this.mediaLibrary.fileSize
      return this.$t('models.mediaLibrary.fileSizePixel', { width: size.width, height: size.height })
    },
    uploadedTime() {
      return basicDateFormat(this.mediaLibrary.fileUploadedAt, this.$t('format.date.lang'))
    }
  }
}
</script>

<style lang="scss" scoped>

.filter {
  &__wrapper {
    align-items: flex-end;
  }
}

.detail {
  &__container {
    height: 100% !important;
  }

  &__title {
    margin-bottom: 12px;
  }
}

.value {
  &__list {
    margin-bottom: 24px;
  }

  &__item {
    padding: 2px;
  }

  &__text {
    font-weight: bold;
  }
}

.p-photos {
  &__image {
    > div {
      background: center center / contain no-repeat;
    }
  }
}

</style>
